'use strict'

import { format, getTime } from 'date-fns';
import { uniq } from 'lodash';

import { loadComponent } from './utils/load-component';
import zonedDate from '../utils/zoned-date';

loadComponent('package-panel-item', {
    props: {
        event: {
            type: Object,
        },
    },
    computed: {
        Date() {
            return format(zonedDate(this.event.PerformanceDate), "EEE, MMM d, yyyy 'at' h:mm aaa");
        },
        UniqueId() {
            return `${this.event.ID}-${getTime(zonedDate(this.event.PerformanceDate))}`
        },
        HasMoreInfo() {
            return this.event.Details || this.event.Artists || this.event.Programs;
        },
        Composers() {
            let composers = this.event.Programs.filter(item => {
                return item.Composer;
            }).map(item => {
                return item.Composer.Title;
            });

            composers = uniq(composers);

            return composers.join(', ');
        },
    },
});
